import { z } from "zod";
export var DmaCalculationRequestErrorKind;
(function (DmaCalculationRequestErrorKind) {
    DmaCalculationRequestErrorKind["Generation"] = "Generation";
    DmaCalculationRequestErrorKind["Validation"] = "Validation";
    DmaCalculationRequestErrorKind["MiniModel"] = "MiniModel";
    DmaCalculationRequestErrorKind["Request"] = "Request";
})(DmaCalculationRequestErrorKind || (DmaCalculationRequestErrorKind = {}));
export const dmaCalculationRequestErrorSchema = z.object({
    kind: z.nativeEnum(DmaCalculationRequestErrorKind),
    message: z.string(),
});
